/*
 * NPM Libraries
 * (TODO) Add additional libraries
 * currently being loaded in dist/index.html
 * ie. Bootstrap, jQuery, jQuery-UI
 *
 */
// TODO-Split: Make sure that Video dial still works with jquery-ui

import $ from 'jquery';
global.$ = global.jQuery = $;

import 'jquery-ui/dist/jquery-ui';
// Bootstrap
import 'bootstrap/js/alert';
import 'bootstrap/js/button';
import 'bootstrap/js/carousel';
import 'bootstrap/js/dropdown';
import 'bootstrap/js/tooltip'
import 'bootstrap/js/popover';
import 'bootstrap/js/scrollspy';
import 'bootstrap/js/tab';
import 'bootstrap/js/collapse'
import 'bootstrap/js/affix';
import 'bootstrap/js/transition';
import 'bootstrap-2.3.2/js/bootstrap-typeahead';
import 'bootstrap-2.3.2/js/bootstrap-modal';
//
// // Plugins
import './jquery-ui-touch-punch-improved/jquery.ui.touch-punch-improved';
import 'jquery.scrollto';
import 'jquery.textnodes/dist/jquery.textnodes';
import 'jquery.shyphen/src/jquery.shyphen';
import './jquery-throttle-debounce/jquery.ba-throttle-debounce';
import 'jquery.uniform/jquery.uniform';
import 'jquery-simulate/jquery.simulate';
import '@fortawesome/fontawesome-free/js/all';

import _ from 'lodash';

window._ = _;
